/** Label3D parser and formatter registration. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseLabel3D } from './parser';
import { formatLabel3DProperties } from './propertyFormatter';
const label3DRegistration = {
    typeName: 'Label3D',
    parser: parseLabel3D,
    propertyFormatter: formatLabel3DProperties,
};
nodeRegistry.register(label3DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map